<div
    class="pb-2 bp908:pb-4 pt-0 bp908:pt-2 w-full bg-p-content-background flex justify-between items-center touch-none"
    [class.opacity-0]="scrollBarWidth === undefined"
    [ngStyle]="{ 'padding-right.px': scrollBarWidth }">
    <div class="ml-[45px] flex text-color font-inter text-base font-semibold items-center">
        <div class="text-14 font-medium">{{ dateStringDisplay }}</div>
        <p-datepicker
            aria-label="Choose calendar date"
            class="ml-2 calendar-datepicker"
            dateFormat="mm.dd.yy"
            [(ngModel)]="selectedDateString"
            [readonlyInput]="true"
            inputStyleClass="!w-0 !p-0 !border-none"
            [showIcon]="true"
            [firstDayOfWeek]="startOfWeekDay"
            [selectOtherMonths]="true"
            panelStyleClass="!mt-2"
            dataType="string"
            icon="pi pi-chevron-down"
            appendTo="body"
            (onSelect)="onSelectDate($event)"
    /></div>

    <div class="flex justify-end items-center">
        @if (maxDaysToShow > 1) {
            @if (viewportService.isSmallDesktop()) {
                <p-button
                    [buttonProps]="{ autofocus: false }"
                    class="w-8"
                    styleClass="w-8 aspect-square"
                    (click)="onCycleNumberOfDays()"
                    severity="secondary"
                    size="small"
                    [outlined]="true"
                    [label]="selectedCalendarModeNumberOfdays">
                    <span class="sr-only">Toggle number of days to show on calendar</span>
                </p-button>
            } @else {
                <p-select
                    aria-label="Change number of days to show on calendar"
                    class="w-[108px]"
                    [tooltipDisabled]="!enableTooltipOndaySelector"
                    pTooltip="Some options disabled due to screen size"
                    size="small"
                    scrollHeight="400"
                    severity="secondary"
                    [options]="calendarViewModeOptions"
                    [ngModel]="selectedCalendarMode"
                    (onChange)="onChangeNumberOfDaysToShow($event)"
                    optionDisabled="disabled"
                    optionLabel="label"
                    optionValue="value">
                </p-select>
            }
        }
        <p-buttonGroup class="ml-2">
            <p-button
                [buttonProps]="{ autofocus: false }"
                severity="secondary"
                [outlined]="true"
                size="small"
                icon="pi pi-chevron-left"
                styleClass="w-8 aspect-square"
                (onClick)="onClickAdvanceBackwards()">
                <span class="sr-only">Go back one day</span>
            </p-button>

            <p-button
                [buttonProps]="{ autofocus: false }"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="min-w-8"
                (onClick)="onClickToday()"
                [label]="viewportService.isSmallDesktop() ? 'T' : 'Today'">
                <span class="sr-only">Go to today</span>
            </p-button>

            <p-button
                [buttonProps]="{ autofocus: false }"
                severity="secondary"
                [outlined]="true"
                size="small"
                icon="pi pi-chevron-right"
                styleClass="w-8 aspect-square"
                (onClick)="onClickAdvanceForward()">
                <span class="sr-only">Go forward one day</span>
            </p-button>
        </p-buttonGroup>
    </div>
</div>
